import mixpanel from 'mixpanel-browser'

const EVENT_NAME = 'CoronaPageVisit'

const trackPageVisit = () => mixpanel.track(EVENT_NAME)

export default trackPageVisit
